import React from "react";
import EnterMobileOtp from "./views/MobileEnterOtp";
import { MobileOtpContextProvider } from "./MobileOtpView";
import LoginContent from "../../../constants/contentFile.json";

const MobileEnterOtp = () => {
  return (
    <MobileOtpContextProvider>
      <EnterMobileOtp textContents={LoginContent.loginPage} />
    </MobileOtpContextProvider>
  );
};

export default MobileEnterOtp;